export const Spinner = (props) => (
  <div style={{margin: props.center ? 'auto' : 0}} className="evt-spinner" />
);
